import request from 'superagent'
import types from '../types'
import config from '../../../package.json'
const { api_port } = config

const { protocol, hostname } = window.location
let apiUrl = `${protocol}//${hostname}:${api_port}/api`
if (api_port === '') {
  apiUrl = `${protocol}//${hostname}/api`
}

const getCarePlanToSignRequested = () => ({
  type: types.GET_CARE_PLAN_TO_SIGN_REQUESTED,
  payload: null
})

const getCarePlanToSignFulfilled = (data: any) => ({
  type: types.GET_CARE_PLAN_TO_SIGN_FULFILLED,
  payload: data
})

const getCarePlanToSignRejected = (error: any) => ({
  type: types.GET_CARE_PLAN_TO_SIGN_REJECTED,
  payload: error
})

export const getCarePlanToSign = (id: number, eid: string, token: string) => {
  return (dispatch: any) => {
    dispatch(getCarePlanToSignRequested())
    request
      .post(`${apiUrl}/carePlanToSign/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send({ eid })
      .then((response) => {
        dispatch(getCarePlanToSignFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(getCarePlanToSignRejected(error))
      })
  }
}

const getCarePlanGridRequested = () => ({
  type: types.GET_CARE_PLAN_GRID_REQUESTED,
  payload: null
})

const getCarePlanGridFulfilled = (data: any) => ({
  type: types.GET_CARE_PLAN_GRID_FULFILLED,
  payload: data
})

const getCarePlanGridRejected = (error: any) => ({
  type: types.GET_CARE_PLAN_GRID_REJECTED,
  payload: error
})

export const getCarePlanGrid = (id: number, eid: string, token: string) => {
  return (dispatch: any) => {
    dispatch(getCarePlanGridRequested())
    request
      .post(`${apiUrl}/carePlanGrid/${id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send({ eid })
      .then((response) => {
        dispatch(getCarePlanGridFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(getCarePlanGridRejected(error))
      })
  }
}

const updateProviderAcknowledgeRequested = () => ({
  type: types.UPDATE_PROVIDER_ACKNOWLEDGE_REQUESTED,
  payload: null
})

const updateProviderAcknowledgeRejected = (error: any) => ({
  type: types.UPDATE_PROVIDER_ACKNOWLEDGE_REJECTED,
  payload: error
})

const updateProviderAcknowledgeFulfilled = (data: any) => ({
  type: types.UPDATE_PROVIDER_ACKNOWLEDGE_FULFILLED,
  payload: data
})

export const updateProviderAcknowledge = (data: any, token: string) => {
  return (dispatch: any) => {
    dispatch(updateProviderAcknowledgeRequested())
    request
      .put(`${apiUrl}/acknowledge`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .send(data)
      .then((response) => {
        dispatch(updateProviderAcknowledgeFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(updateProviderAcknowledgeRejected(error))
      })
  }
}